 <!-- 专题讲座管理-学员管理-新增学员 -->
<template>
  <el-dialog
    class="dialog"
    title="新增学员"
    width="1100px"
    :visible.sync="showDirectMemberSelect.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <search :examType="2" ref="search" @search="searchHandle" />
    <div class="main-contant">
      <div class="left-tree">
        <DeptTree
          :loadNode="loadNode"
          :deptTreeData="deptTreeData"
          :props="props"
          @select="select"
          @searchDep="searchDep"
          ref="treeMent"
          showTooltip
        />
      </div>
      <div class="right-table">
        <el-table
          ref="pageListTable"
          border
          :data="tableData"
          :row-key="getRowKeys"
          :row-style="{ color: '#51627D', fontWeight: 400 }"
          :header-row-style="{ color: '#343C4A', fontWeight: 500 }"
          @selection-change="handleSelectionChanges"
        >
          <el-table-column
            type="selection"
            :selectable="selectInit"
            :reserve-selection="true"
            width="40"
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            show-overflow-tooltip
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="单位"
            show-overflow-tooltip
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="unitPosition"
            label="单位及职务"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-size="size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          hide-on-single-page
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Search from "@/views/examInfo/members/memsSearch.vue";
import DeptTree from "@/views/onlineClass/students/deptTree.vue";
import { deptTreeForClass } from "@/api/dept";
import { pageByDepts } from "@/api/user";
import { topicLectureInfoUserSave } from "@/api/studyService";
import { filterLevelCode } from "@/utils/common.js";

export default {
  components: {
    Search,
    DeptTree,
  },
  props: {
    defaultCheckedKeys: {
      type: Array,
      default: () => [],
    },
    topicLectureInfoId: {
      type: String,
      default: "",
    },
    showDirectMemberSelect: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      getRowKeys(row) {
        return row.uuid;
      },
      props: {
        //树形
        label: "deptName",
        isLeaf: "isLeaf",
      },
      deptTreeData: [],
      selectedMembers: [],
      tableData: [],
      deptId: "",
      total: 0,
      currentPage: 1,
      size: 10,
      userIdList: new Set(),
      nowPageIds: [],
      hasIds: [],
      originListSet: [],
    };
  },
  created() {
    if (this.defaultCheckedKeys) {
      this.selectedMembers = JSON.parse(JSON.stringify(this.defaultCheckedKeys));
      this.originListSet = this.selectedMembers;
      this.hasIds = this.defaultCheckedKeys;
      deptTreeForClass({
        bNotAcrossDept: 0
      }).then((res) => {
        if (res.data && res.data.length > 0) {
          this.deptTreeData = res.data;
          this.deptTreeData.map((v) => {
            if (v.hasChildren == 0) v.isLeaf = true;
          });
          // this.$refs.treeMent.deptTreeData = this.deptTreeData;
          this.deptId = res.data[0].id;
        }
      });
    }
  },
  methods: {
    searchDep(val) {
      this.deptTreeData = [];
      deptTreeForClass({ deptName: val, bNotAcrossDept: 0 }).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.map((v) => {
            if (v.hasChildren == 0) {
              v.isLeaf = true;
            }
          });
          this.deptTreeData = res.data;
        }
      });
    },
    loadNode(node, resolve) {
      // console.log(node);
      if (node.level === 0) {
        return resolve(this.deptTreeData);
      }
      if (node.level >= 1) return this.getChildNode(node, resolve);
    },
    getChildNode(node, resolve) {
      setTimeout(() => {
        deptTreeForClass({
          parentId: node.data.uuid || "",
          bNotAcrossDept: 0
        }).then((res) => {
          res.data.map((v) => {
            if (v && v.hasChildren == 0) {
              v.isLeaf = true;
            } else {
              v.isLeaf = false;
            }
            resolve(res.data);
          });
        });
      }, 300);
    },
    cancel() {
      this.$emit("closeManage");
    },
    select(obj) {
      this.currentPage = 1;
      this.deptId = obj.deptId;
      this.getList(this.$refs.search.filters);
    },
    handleSelectionChanges(rows) {
      // 并集
      let selectRowsArr = rows.map((x) => x.uuid);
      let union = Array.from(
        new Set([...this.originListSet, ...selectRowsArr])
      );
      this.selectedMembers = union;
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList(this.$refs.search.filters);
    },
    sizeChange(size) {
      this.size = size;
      this.getList(this.$refs.search.filters);
    },
    selectInit(row) {
      if (this.hasIds.length > 0) {
        return !this.hasIds.includes(row.uuid);
      }
      return true;
    },
    // 历史选中回显置灰
    getList(param) {
      let params = {
        page: this.currentPage,
        limit: this.size,
        // classId: this.examId,
      };
      if (param && param.leaderTypeMore && param.leaderTypeMore.length == 0) {
        delete param.leaderTypeMore;
      }
      if (Array.isArray(this.deptId) && this.deptId.length > 0) {
        params.deptLevelCodes = this.deptId;
      } else {
        params.deptLevelCodes = this.deptId;
      }
      if (params.deptLevelCodes) {
        params.deptLevelCodes = filterLevelCode(params.deptLevelCodes);
      } else {
        params.deptLevelCodes = [];
      }
      pageByDepts({
        ...params,
        ...param,
      }).then(({ code, data }) => {
        if (code !== 0) return;
        let { records, total } = data;
        this.tableData = records;
        this.total = total;
        this.nowPageIds = this.tableData.map((x) => x.uuid);
        let rows = [];
        this.selectedMembers.map((x) => {
          this.userIdList.add(x);
        });
        this.nowPageIds.forEach((x, i) => {
          if (Array.from(this.userIdList).includes(x)) {
            rows.push(this.tableData[i]);
          }
        });
        setTimeout(() => {
          rows.forEach((row) => {
            this.$refs.pageListTable.toggleRowSelection(row, true);
          });
        }, 200);
      });
    },
    // 条件筛选
    searchHandle(data) {
      this.currentPage = 1;
      this.getList(data);
    },
    confirm() {
      const newAddStudents = this.selectedMembers.filter((uuid) => !this.defaultCheckedKeys.includes(uuid));
      if (this.selectedMembers.length === 0) {
        this.$message({
          message: "请选择用户",
          type: "warning",
        });
      } else if (newAddStudents.length > 1000) {
        this.$message({
          message: "单次添加学员上限1000人！",
          type: "warning",
        });
      } else {
        topicLectureInfoUserSave({
          topicLectureInfoId: this.topicLectureInfoId,
          userIdList: newAddStudents,
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.$emit("addSucceed");
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-contant {
  display: flex;
  min-height: 500px;
}
.left-tree {
  width: 350px;
  margin-right: 10px;
  max-height: 450px;
}
.right-table {
  flex: 1;
}
.top-filter {
  margin-bottom: 10px;
}
.pagination {
  float: right;
}
.name-input {
  width: 250px;
  margin-right: 10px;
}
$text-color: #51627d;
$text-font: 14px;
@mixin text {
  color: $text-color;
  font-size: $text-font;
}
@mixin border {
  border: 1px solid #d7dbe0;
  border-radius: 2px;
}
@mixin panel {
  width: 48%;
  height: 300px;
  box-sizing: border-box;
  overflow: hidden;
}
.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;
    .left-panel {
      float: left;
      @include border;
      padding: 10px;
      @include panel;
    }
    .right-panel {
      float: right;
      @include border;
      @include panel;
    }
    .member-tree {
      margin-top: 10px;
      height: calc(100% - 42px);
      overflow-y: auto;
      /deep/ .el-tree-node__label {
        @include text;
      }
    }
    .panel-header {
      background-color: #f2f3f4;
      height: 44px;
      display: flex;
      padding: 0 15px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      & > span:first-child {
        @include text;
      }
    }
    .member-list {
      height: calc(100% - 64px);
      overflow-y: auto;
      margin: 10px 0;
      padding: 0 10px;
      li {
        list-style: none;
        padding: 8px 10px;
        @include text;
        &:hover {
          background-color: #3a85ff;
          color: #fff;
        }
      }
    }
  }
}
</style>
